import React from "react";
import "./QpDatepicker.scss";

interface IQpDatepickerProps {
  defaultSelectedDate?: string;
  minDate?: string;
  maxDate?: string;
  label: string;
  onChange: (date: string) => void;
  readonly?: boolean;
}

const QpDatepicker: React.FC<IQpDatepickerProps> = ({
  defaultSelectedDate,
  minDate,
  maxDate,
  label,
  onChange,
  readonly,
}) => {
  const ref = React.useRef<HTMLElement>(null);
  const onChangeRef = React.useRef(onChange);
  const defaultSelectedDateRef = React.useRef(defaultSelectedDate);
  onChangeRef.current = onChange;

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const handleCustomEvent = (e: Event) => {
      const detail = (e as CustomEvent<{ selectedDate: string }>).detail;
      onChangeRef.current(detail?.selectedDate ?? "");
    };

    const handleNativeChange = (e: Event) => {
      const target = e.target as HTMLInputElement;
      if (target.tagName === "INPUT") {
        onChangeRef.current(target.value);
      }
    };

    el.addEventListener("qp-datepicker-changed", handleCustomEvent);
    el.addEventListener("change", handleNativeChange);
    return () => {
      el.removeEventListener("qp-datepicker-changed", handleCustomEvent);
      el.removeEventListener("change", handleNativeChange);
    };
  }, []);

  return (
    <qp-datepicker
      ref={ref as any}
      data-selected-date={defaultSelectedDateRef.current}
      data-min-date={minDate}
      data-max-date={maxDate}
      data-use-native={true}
      data-label={label}
      data-readonly={!!readonly}
    ></qp-datepicker>
  );
};

export default QpDatepicker;
